
import { FETCH_SasData_REQUEST, FETCH_SasData_SUCCESS, FETCH_SasData_FAILURE } from './actionsTypes';

export const fetchSasDataRequest = (token,history) => ({
  type: FETCH_SasData_REQUEST,
  payload: { token,history },
});

export const fetchSasDataSuccess = (sasData) => ({
  type: FETCH_SasData_SUCCESS,
  payload: { sasData },
});

export const fetchSasDataFailure = (error) => ({
  type: FETCH_SasData_FAILURE,
  payload: { error },
});

